module.exports = __webpack_public_path__ + "static/profile-john-ed3c7bcc8ee6e815864c72b9262234e7.jpg";